module.exports = __webpack_public_path__ + "img/denial.a8710602.png";